export default __webpack_public_path__ + "static/media/bag11.c1fcb5a7.jfif";